import {  
    getFirestore,
    doc,
    collection,
    addDoc,
    setDoc,
    deleteDoc,
    // serverTimestamp
} from "firebase/firestore";
import setUserInfo from "./setUserInfo";
import getProgramInfoById from "./getProgramInfoById";
const setProgramInfo = async function(data, id, userId) {
    let db = getFirestore();
    let ref = collection(db, "wellness_program");
    if( id != undefined ){
        if( data.action == undefined ){
            ref = doc( db, "wellness_program", id );
            await setDoc(ref, data, {merge: true});
        }
        if( userId != undefined ){
            if( data.action == 'memberInfo' ){
                ref = doc(db, "wellness_program", id, "members", userId);
                await setDoc( ref, data, {merge: true});

                //to update onsiteCount
                ref = doc(db, "wellness_program", id, "members", userId);
                const programUpdate = await getProgramInfoById(id, userId, 1);
                await setDoc( ref, {onsiteCount: programUpdate.onsiteCount}, {merge: true});
            }
            else if( data.action.startsWith('onsite') ){
                // data = {
                //     date: '',
                //     source: {
                //         weight: '',
                //         fat: '',
                //         pressure: '',
                //     },
                //     program: {
                //         height: '',
                //         weight: '',
                //         bmi: '',
                //         waist: '',
                //         hip: '',
                //         whr: '',
                //         program: ''
                //     },
                //     weight: {
                //         category: 'weight',
                //         weight: '',
                //         height: '',
                //         bmi: '',
                //     },
                //     fat: {
                //         category: 'fat',
                //         waist: '',
                //         // programe: ''
                //     }
                //     pressure: {
                //         category: 'pressure',
                //         pressureLower: '',
                //         pressureUpper: '',
                //         // programe: ''
                //     }
                // };
                
                //set source 
                let timestamp = data.date.getTime();
                if( !data.program.source.weight ){
                    data.program.source.weight = '/wellness_data/' + userId + '/healthdata/' + timestamp.toString();
                }
                if( !data.program.source.fat ){
                    data.program.source.fat = '/wellness_data/' + userId + '/healthdata/' + ((timestamp+1).toString());
                }
                if( !data.program.source.pressure ){
                    data.program.source.pressure = '/wellness_data/' + userId + '/healthdata/' + ((timestamp+2).toString());
                }
                if( data.weight.category != undefined ){
                    ref = doc(db, data.program.source.weight);
                    await setDoc( ref, data.weight, {merge: false} );
                }
                else{
                    ref = doc(db, data.program.source.weight);
                    await deleteDoc( ref );
                }

                if( data.fat.category != undefined ){
                    ref = doc(db, data.program.source.fat);
                    await setDoc( ref, data.fat, {merge: false} );
                }
                else{
                    ref = doc(db, data.program.source.fat);
                    await deleteDoc( ref );
                }
                if( data.pressure.category != undefined ){
                    ref = doc(db, data.program.source.pressure);
                    await setDoc( ref, data.pressure, {merge: false} );
                }
                else{
                    ref = doc(db, data.program.source.pressure);
                    await deleteDoc( ref );
                }

                //old
                // ref = doc(db, "wellness_program", id, "members", userId);
                // let programData = {};
                // programData[data.action] = data.program;
                // programData['target'] = data.target;
                // await setDoc( ref, programData, {merge: true});

                //new
                data.program['target'] = data.target;
                let programData2 = data.program;
                console.log(programData2);
                ref = doc(db, "wellness_program", id, "members", userId, 'onsite', data.action);
                await setDoc( ref, programData2 );

                //to update onsiteCount
                ref = doc(db, "wellness_program", id, "members", userId);
                const programUpdate = await getProgramInfoById(id, userId, 1);
                await setDoc( ref, {onsiteCount: programUpdate.onsiteCount}, {merge: true});

            }
            else if( data.action == 'endProgram' ){
                ref = doc(db, "wellness_program", id, "members", userId);
                await setDoc( ref, { 
                    endDate: data.endDate, 
                    programResult: data.programResult, 
                    programSummary: data.programSummary,
                    isCompleteProgram: true 
                }, {merge: true});
                //await setUserInfo(userId, { currentProgram: ''});
            }
            else if( data.action == 'cancelProgram' ){
                //clear onsite data : 20240319 do not need to clear onsite
                // const programInfo = await getProgramInfoById(id, userId, 1);
                // for (let i = 1; i <= programInfo['memberOnsite']; i++) {
                //     ref = doc(db, "wellness_program", id, "members", userId, "onsite", "onsite" + i);
                //     await deleteDoc( ref );
                // }

                ref = doc(db, "wellness_program", id, "members", userId);
                await setDoc( ref, { 
                    cancelDate: data.cancelDate, 
                    programResult: data.programResult,
                    programResultOther: data.programResultOther,
                    isCancelProgram: true 
                }, {merge: true});

                // await setUserInfo(userId, { currentProgram: ''});
            }
            else if( data.action == 'delete' ){
                ref = doc(db, "wellness_program", id, "members", userId);
                await deleteDoc( ref );
                await setUserInfo(userId, { currentProgram: ''});
            }
            else if( data.action == 'addMember' ){
                //clear onsite data : 20240319 do not need to clear onsite
                // const programInfo = await getProgramInfoById(id, userId, 1);
                // for (let i = 1; i <= programInfo['memberOnsite']; i++) {
                //     ref = doc(db, "wellness_program", id, "members", userId, "onsite", "onsite" + i);
                //     await deleteDoc( ref );
                // }
                
                ref = doc(db, "wellness_program", id, "members", userId);
                await setDoc( ref, { uid: userId, groupId: data.groupId, addedBy: data.addedBy, addedDate: new Date(), memberOnsite: 2 });
                await setUserInfo(userId, { currentProgram: id});
            }
        }
    }
    else{
        await addDoc(ref, data);
    }

};
export default setProgramInfo;